import React from 'react'
import useTranslation from '../../../hooks/use-translation';
import BackArrow from '../../../images/ic_back_2.svg'
import { closeView } from '../../../utils/call-my-jio';


const Header = ({ headerFor = 'slotList' }) => {
  const { t } = useTranslation();
  const slotListHeader = () => (
    <div style={{
      textAlign: 'center',
      position: 'absolute',
      width: '-webkit-fill-available'
    }}>
      <div style={{
        position: 'absolute', fontFamily: 'JioType-Medium', fontSize: '14px', color: '#FFFFFF',
        margin: '1em auto',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '0.5fr 3fr 0.5fr',
        placeContent: 'center',
        alignItems: 'center',
      }}>
        <img style={{ marginLeft: '8px' }} src={BackArrow} onClick={closeView} width='30' height='30' />
        <span>{t('VACCINE_FINDER')}</span>
      </div>
      <div style={{ backgroundSize: '100% 100%' }}>
        <img src={'/icons/Background_img.png'} style={{
          background: 'transparent linear-gradient(270deg, #26C0F7 0%, #367CFF 100%) 0% 0% no-repeat padding-box',
          borderRadius: '0 0 10px 10px',
          objectFit: 'cover',
          opacity: '1',
          width: '100%',
          height: '500px'
        }} />
      </div>
    </div>
  )

  const landingPageHeader = () => (
    <div style={{
      textAlign: 'center',
      position: 'relative'
    }}>
      <div style={{
        position: 'fixed', fontFamily: 'JioType-Bold', fontSize: '20px', color: '#FFFFFF',
        textTransform: 'uppercase', margin: '1em auto',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '0.5fr 3fr 0.5fr',
        placeContent: 'center',
        alignItems: 'center',
        zIndex: 4000
      }}>
        <img style={{ marginLeft: '8px' }} src={BackArrow} onClick={closeView} width='30' height='30' />
      </div>
      <div style={{
        position: 'fixed', fontFamily: 'JioType-Bold', fontSize: '26px', color: '#FFFFFF', display: 'flex',
        flexDirection: 'column',
        textTransform: 'uppercase', margin: '3em auto',
        width: '100%',
        placeContent: 'center',
        alignItems: 'center',
      }}>
        <span >{t('VACCINE_FINDER')}</span>
      </div>
      <img src={'/icons/Background_img.png'} style={{
        background: 'transparent linear-gradient(270deg, #26C0F7 0%, #367CFF 100%) 0% 0% no-repeat padding-box',
        borderRadius: '0 0 10px 10px',
        opacity: '1',
        width: '100%'
      }} />
    </div>
  )
  const header = {
    'slotList': slotListHeader(),
    'landingPage': landingPageHeader()
  }

  return (
    <div>{header[headerFor]}</div>
  )
}

export default Header